import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";

import { ACCOUNTANT_HOME_PATH, isAccountantAllowedPathname } from "./accountantAllowlist";
import { useCurrentUserStaff } from "@/hooks/useCurrentUserStaff";
import { PageLoader } from "@/components/ui/page-loader";

/**
 * Accountant allowlist by live pathname, mounted around the authenticated
 * Layout (src/App.tsx GuardedLayout) so routes that never pass through
 * RouteGateGuard (index RootRoute, registry redirects, future direct mounts)
 * are covered too. While the staff record loads on a non-allow-listed path,
 * render the loader instead of the page — never flash it to an accountant.
 */
export function AccountantRouteEnforcer({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { currentUserStaff, isLoading } = useCurrentUserStaff();
  const allowedPath = isAccountantAllowedPathname(location.pathname);

  if (!allowedPath && isLoading) return <PageLoader />;
  if (!allowedPath && currentUserStaff?.role === "accountant") {
    return <Navigate to={ACCOUNTANT_HOME_PATH} replace />;
  }

  return <>{children}</>;
}
